import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FiberPinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fiber_pin"}/>
}
